import VueRouter, { RouteConfig } from 'vue-router'

const LayoutEmpty = () => import('../views/LayoutEmpty.vue')

const GiftPacksActivity = () => import('../views/GiftPacksActivity.vue')

export const giftPacksRoute: RouteConfig = {
  path: 'gift-packs',
  name: 'gift_packs_activity',
  component: GiftPacksActivity,
  meta: {
    title: '体智云大礼包',
  },
}

export default [
  {
    path: '/activity',
    name: 'activity',
    component: LayoutEmpty,
    children: [giftPacksRoute],
  },
]

export function navigateToGiftPacksActivity(router: VueRouter) {
  router.push({ name: giftPacksRoute.name })
}
